<div class="container">
    <div class="row" *ngIf="sent">
      <div class="col-md-6 offset-md-3 order-sm-12 m-t-40 m-b-10">
        <p class="alert alert-success">
          {{ 'forgot.success' | translate }}
        </p>
      </div>
    </div>
    <div class="row" *ngIf="!sent">
        <div class="col-md-6 offset-md-3 m-t-40 m-b-10">
            <alert></alert>
            <h2>{{ 'forgot.title' | translate }}</h2>
            <form name="form" (ngSubmit)="f.form.valid && forgot()" #f="ngForm" novalidate>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
                    <input type="text" class="form-control" name="email" placeholder="{{ 'forgot.email' | translate }}" [(ngModel)]="model.email" #email="ngModel" required />
                    <div *ngIf="f.submitted && !email.valid" class="help-block">{{ 'forgot.emailhelp' | translate }}</div>
                </div>
                <div class="form-group">
                    <button [disabled]="loading" class="btn btn-primary">{{ 'forgot.button' | translate }}</button>
                    <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                </div>
                <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                <div class="form-group">
                  <div class="col-xs-10 col-xs-offset-3 text-left">
                    <a [routerLink]="['/login/.']">{{ 'forgot.back' | translate }}</a>
                  </div>
                </div>
            </form>
        </div>
    </div>
</div>